import {
  flash,
  tapFlashError,
  tapFlashSuccess,
} from '../../generic/flash-messages';
import api from '../../REST/api';
import createUiAction, { markUiAction } from '../../utils/create-ui-action';

export const fetchContentfulCreatives = () => (dispatch, getState) => {
  const { contentfulCreatives, campaignEditor } = getState();
  if (!campaignEditor) return [];
  const { campaign } = campaignEditor;
  if (contentfulCreatives.length) {
    return Promise.resolve({ value: contentfulCreatives });
  }
  return dispatch(
    markUiAction({
      type: fetchContentfulCreatives.toString(),
      payload: api.getContentfulCreatives({ id: campaign.id }),
    }),
  );
};

fetchContentfulCreatives.toString = () => 'contentful-creatives/fetch';

export const addContentfulCreatives = additionalCreative => ({
  type: addContentfulCreatives.toString(),
  payload: additionalCreative,
});

addContentfulCreatives.toString = () => 'contentful-creatives/add';

export const updateContentfulCreatives = updatedCreative => ({
  type: updateContentfulCreatives.toString(),
  payload: updatedCreative,
});

updateContentfulCreatives.toString = () => 'contentful-creatives/update';

export const saveAllContentfulCreatives = () => (dispatch, getState) => {
  const { contentfulCreatives, campaignEditor } = getState();
  const { campaign } = campaignEditor;
  dispatch(flash('Saving contentful creatives…', 'info'));

  return dispatch(
    markUiAction({
      type: saveAllContentfulCreatives.toString(),
      payload: api
        .addContentfulCreatives({
          id: campaign.id,
          data: { contentfulCreatives },
        })
        .then(
          tapFlashSuccess(
            dispatch,
            'Contentful creatives updated successfully',
          ),
          tapFlashError(dispatch),
        ),
    }),
  );
};

saveAllContentfulCreatives.toString = () => 'contentful-creatives/save-all';

export const deleteContentfulCreatives = id => (dispatch, getState) => {
  const { campaignEditor, contentfulCreatives } = getState();
  const contentfulCreative =
    contentfulCreatives.find(creative => creative.contentId === id) || {};
  const { campaign } = campaignEditor;
  const isContentIdSaved = !!contentfulCreative.id;
  return isContentIdSaved
    ? dispatch(
        markUiAction({
          type: deleteContentfulCreatives.toString(),
          payload: api
            .destroyContentfulCreatives(campaign.id, contentfulCreative.id)
            .then(
              tapFlashSuccess(dispatch, 'Content Id deleted successfully'),
              tapFlashError(dispatch),
            ),
          meta: { id },
        }),
      )
    : dispatch({
        type: `${deleteContentfulCreatives.toString()}-success`,
        meta: { id },
      });
};
deleteContentfulCreatives.toString = () => 'contentful-creatives/delete';

export const clearContentfulCreatives = createUiAction(
  'contentful-creatives/clear',
  task => task,
);
